<div class="home-container">
    <div class="row">
        <div class="col-md-6">
            <div class="card" 
            [class.active]="activeMetric === 'events'" 
            style="background-image: url('assets/events_card_back.jpg');"
            [routerLink]="'/events'">
                <div class="card-title">
                    Eventos
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card" 
            style="background-image: url('assets/calendar_card.jpg');"
            [routerLink]="'/calendar'"
            [class.active]="activeMetric === 'followers'">
                <div class="card-title">
                    Calendario
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card block" 
            style="background-image: url('assets/reservations_card.jpg');"
            [class.active]="activeMetric === 'followers'">
                <div class="card-title">
                    Reservas
                </div>
                <div class="card-construction">
                    <img src="assets/construction.png">
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card block" 
            style="background-image: url('assets/interactions_card.jpg');"
            [class.active]="activeMetric === 'followers'">
                <div class="card-title">
                    Interacciones
                </div>
                <div class="card-construction">
                    <img src="assets/construction.png">
                </div>
            </div>
        </div>
    </div>
</div>
